import { useRef } from "react";
import { motion } from "framer-motion";

export default function TiltCard({ children, className, testid, delay = 0 }) {
  const inner = useRef(null);

  const onMove = (e) => {
    const el = inner.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(1000px) rotateX(${(-y * 5).toFixed(2)}deg) rotateY(${(x * 5).toFixed(2)}deg)`;
  };

  const onLeave = () => {
    if (inner.current) {
      inner.current.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg)";
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
      data-testid={testid}
      className="h-full"
    >
      <div
        ref={inner}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className={`${className} h-full transition-transform duration-200 will-change-transform`}
        style={{ transformStyle: "preserve-3d" }}
      >
        {children}
      </div>
    </motion.div>
  );
}
